/*!
 * OnSchedJ (http://onsched.com)
 * Copyright 2014-2023 OnSched
 */

'use strict';

import './assets/css/index.css'; 
import './assets/sass/onsched.sass'

import { OnSchedElements } from './OnSchedMounts';
import { OnSchedRest }     from './OnSchedRest';
import { OnSchedUtils }    from './utils';
import React               from 'react';
import ReactDOM            from 'react-dom/client';


const OnSched = (ClientId, Environment, Options) => {
  let state = {};
  
  const setState = (newState) => {
    state = newState;
  }

  let self = {};
  self.objectName = "OnSched";
  self.scope = Options === undefined ? "OnSchedApi" : Options.scope;
  self.locale = Options === undefined || Options.locale == null ? "en-US" : Options.locale;
  self.language = Options?.language?.length > 0 ? Options.language : 'en';
  self.detectLocale = Options?.detectLocale ? Options.detectLocale : false;
  self.access_token = Options?.access_token ? Options.access_token : null;
  self.theme = Options?.theme?.length > 0 ? Options.theme : 'primary';
  self.clientId = ClientId;
  self.environment = Environment === null ? "sbox" : Environment;

  switch (self.environment) {
    case "live":
      self.jsApiBaseUrl      = 'https://js.onsched.com/api/onsched';
      self.apiBaseUrl      = 'https://js.onsched.com/api/onsched/consumer';
      self.setupApiBaseUrl = 'https://js.onsched.com/api/onsched/setup';
      break;
    case "sbox":
      self.jsApiBaseUrl      = 'https://sandbox-js.onsched.com/api/onsched';
      self.apiBaseUrl      = 'https://sandbox-js.onsched.com/api/onsched/consumer';
      self.setupApiBaseUrl = 'https://sandbox-js.onsched.com/api/onsched/setup';
      break;
    case "dev":
      self.jsApiBaseUrl      = 'https://dev-js.onsched.com/api/onsched';
      self.apiBaseUrl      = 'https://dev-js.onsched.com/api/onsched/consumer';
      self.setupApiBaseUrl = 'https://dev-js.onsched.com/api/onsched/setup';
      break;
    default:
      self.jsApiBaseUrl      = 'https://sandbox-js.onsched.com/api/onsched';
      self.apiBaseUrl      = 'https://sandbox-js.onsched.com/api/onsched/consumer';
      self.setupApiBaseUrl = 'https://sandbox-js.onsched.com/api/onsched/setup';
      break;
  }

  self.elements = () => {
    let elements = {};
    elements.objectName = "OnSched.elements";
    // elements.create method for creating an element
    elements.create = (type, params, options) => {
      let element = {};

      element.onsched = self;
      element.onsched.state = state;
      element.onsched.setState = setState;
      element.objectName = "OnSched.element";
      element.type = type;

      // check for params based on type? e.g. date is not relevant for all types
      element.params = params;
      element.options = options;

      element.mount = (id) => {
        element.id = id;

        const el = document.getElementById(id);
        
        // Add theme class to element
        el.className = `onschedjs-element onsched-theme-${self.theme} sm md lg`;

        // TODO - raise app error event
        if (el === null) {
          throw "OnSched.mount: DOM Element with id=" + id + " doesn't exist.";
        }

        // Add size to element
        var breakpointObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
              // Add resize event for using OnSched.js Elements in an iFrame
              // OnSchedUtils.UtilityCustomEvents.ResizeElement(element, entry.contentRect)
                if (entry.contentRect.width >= 992) {
                    if (!el.classList.contains('lg')) {
                        el.classList.add('lg')
                    }
                    if (!el.classList.contains('md')) {
                        el.classList.add('md')
                    }
                    if (!el.classList.contains('sm')) {
                        el.classList.add('sm')
                    }
                }
                else if (entry.contentRect.width >= 768) {
                    if (el.classList.contains('lg')) {
                        el.classList.remove('lg')
                    }
                    if (!el.classList.contains('md')) {
                        el.classList.add('md')
                    }
                    if (!el.classList.contains('sm')) {
                        el.classList.add('sm')
                    }
                }
                else {
                    if (el.classList.contains('lg')) {
                        el.classList.remove('lg')
                    }
                    if (el.classList.contains('md')) {
                        el.classList.remove('md')
                    }
                    if (!el.classList.contains('sm')) {
                        el.classList.remove('sm')
                    }
                }
            }
        });

        breakpointObserver.observe(el);

        const e = React.createElement;
        const domContainer = document.querySelector(`#${id}`);
        const root = ReactDOM.createRoot(domContainer);
        
        // Window OnClick Events
        domContainer.addEventListener('click', e => {
          
        })

        const access_token_missing = !Boolean(self.access_token) && (Boolean(element.type === 'calendar') || Boolean(element.type.includes('Setup')));

        if (access_token_missing) {
          throw "Unauthorized access, Setup Elements require an access token.";
        }
        else {
          if (!self.authorized) {
            OnSchedRest.Authorize({clientId:self.clientId, environment: self.environment, scope: self.scope, access_token: self.access_token})
              .then(authorized => {
                if (authorized) {
                  self.authorized = authorized;
                  root.render(e(OnSchedElements[type], element));
                }
                else {
                  throw "Unauthorized access, please check your client credentials.";
                }
            });
          }
          else {
            root.render(e(OnSchedElements[type], element));
          }
        }
      }
      element.unmount = id => {
        const el = document.getElementById(id);

        el.innerHTML = '';
      }

      if (Boolean(element.type === 'apiRequest')) {
        const respondAPI = response => OnSchedUtils.CustomEvents('apiRequest', 'apiResponse', { detail: response });

        if (!self.access_token) {
          throw "Unauthorized access, direct API Request require an access token.";
        }
        else {
          element.get = id => {
            const url = element.params.interface === 'consumer' ? element.onsched.apiBaseUrl + '/' + element.params.requestUrl : element.onsched.setupApiBaseUrl + '/' + element.params.requestUrl;
            OnSchedRest.Get(url, response => OnSchedUtils.CustomEvents(id, 'apiResponse', respondAPI))
          }
          element.post = id => {
            const url = element.params.interface === 'consumer' ? element.onsched.apiBaseUrl + '/' + element.params.requestUrl : element.onsched.setupApiBaseUrl + '/' + element.params.requestUrl;
            OnSchedRest.Post(url, element.params.payload, response => OnSchedUtils.CustomEvents(id, 'apiResponse', element.params.payload, respondAPI))
          }
          element.put = id => {
            const url = element.params.interface === 'consumer' ? element.onsched.apiBaseUrl + '/' + element.params.requestUrl : element.onsched.setupApiBaseUrl + '/' + element.params.requestUrl;
            OnSchedRest.Put(url, element.params.payload, response => OnSchedUtils.CustomEvents(id, 'apiResponse', element.params.payload, respondAPI))
          }
          element.delete = id => {
            const url = element.params.interface === 'consumer' ? element.onsched.apiBaseUrl + '/' + element.params.requestUrl : element.onsched.setupApiBaseUrl + '/' + element.params.requestUrl;
            OnSchedRest.Delete(url, element.params.payload, response => OnSchedUtils.CustomEvents(id, 'apiResponse', element.params.payload, respondAPI))
          }
        }
      }

      return element;
    }

    return elements;
  }

  return self;
}

export {
  OnSched
}
